module.exports = __webpack_public_path__ + "static/img/32-翠湖小学(白水洼校区)1.e8cccf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/32-翠湖小学(白水洼校区)1.png
// module id = ig4k
// module chunks = 0